import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SplitButtonWrapper = styled.div`
  box-sizing: border-box;
  width: fit-content;
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  color: ${Color.Black};
  ${getShadow('raisedLight', { borderColor: Color.Grey200 })};
`

export const AddButtonWrapper = styled.div`
  &:hover {
    border-top-left-radius: ${BorderRadius.R12};
    border-bottom-left-radius: ${BorderRadius.R12};
    background-color: ${Color.Grey100};
  }

  &:active {
    border-top-left-radius: ${BorderRadius.R12};
    border-bottom-left-radius: ${BorderRadius.R12};
    background-color: ${Color.Grey150};
  }
`

export const TriggerButtonWrapper = styled.div`
  padding: ${Spacing.S4};
`
